if (!customElements.get('hh-product-details-toggle')) {
  customElements.define('hh-product-details-toggle', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.button = this.querySelector('[data-specifications-toggle]');
      this.content = this.querySelector('[data-specifications-list]');
      if (!this.button || !this.content) return;
      this.limit = Math.max(1, Number(this.dataset.limit) || 12);
      this.button.addEventListener('click', () => {
        this.expanded = !this.expanded;
        this.refresh();
        if (!this.expanded) this.button.scrollIntoView({block: 'nearest'});
      }, {signal: this.controller.signal});
      this.observer?.disconnect();
      this.observer = new MutationObserver(() => this.refresh());
      this.observer.observe(this.content, {childList: true, subtree: true});
      this.refresh();
    }
    refresh() {
      const rows = [...this.content.querySelectorAll('[data-specification-content] > ul > li')]
        .filter(row => row.style.display !== 'none' && (!row.hidden || row.hasAttribute('data-hh-specification-collapsed')));
      const overflow = rows.length > this.limit;
      if (!overflow) this.expanded = false;
      rows.forEach((row, index) => {
        const collapsed = !this.expanded && index >= this.limit;
        row.toggleAttribute('data-hh-specification-collapsed', collapsed);
        row.hidden = collapsed;
      });
      this.button.hidden = !overflow;
      this.button.setAttribute('aria-expanded', String(Boolean(this.expanded)));
      this.button.textContent = this.expanded ? this.dataset.showLess : this.dataset.showAll.replace('__COUNT__', String(rows.length));
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}
